import { UIInputState } from '../../models/state-to-ui-input-state';
import { ReactNode } from 'react';
import styles from './InputStateBoxUI.module.scss';
import { IInputPrimaryState } from '../../models/input.model';

export interface IInputStateBoxUI {
  hasFocus?: boolean;
  primaryState?: IInputPrimaryState;
  children: ReactNode;
  icon?: ReactNode;
}

/**
 * @warning This component is pretty much redundant, in ui-core the state is contained in the input.
 * This is temporary...
 *
 */

export const InputStateBoxUI = ({
  hasFocus,
  primaryState = 'undetermined',
  icon,
  children,
}: IInputStateBoxUI) => {
  return (
    <span className={styles.root} data-state={UIInputState[primaryState]}>
      {children}
    </span>
  );
};

export default InputStateBoxUI;
